import { IsolationControllerProvider } from 'features/knowledgeDocumentViewer/graph/IsolationControllerContext'
import { NodeFocusRequestProvider } from 'features/knowledgeDocumentViewer/graph/NodeFocusRequestContext'
import type { LotoDrawing } from 'features/lotoReports/useLotoDocumentTab'
import type { ReactElement, ReactNode } from 'react'

export function LotoDrawingProviders({
  drawing,
  children,
}: {
  drawing: LotoDrawing
  children: ReactNode
}): ReactElement {
  return (
    <IsolationControllerProvider value={drawing.controller}>
      <NodeFocusRequestProvider value={drawing.pendingFocus}>
        {children}
      </NodeFocusRequestProvider>
    </IsolationControllerProvider>
  )
}
